import React, {useContext} from "react";
import {AuthenticationContext} from "../../context/auth";
import {useForm} from "react-hook-form";
import {Navigate} from "react-router-dom";

export function Login(){
    const {login, isAuthenticated, errors} = useContext(AuthenticationContext);
    const { register, handleSubmit } = useForm();
    const onSubmit = (data, e) => {
        login(data.email, data.password);
    };
    const onError = (errors, e) => console.log(errors, e);

    /*function handleSubmit(e){
        e.preventDefault();
        login();
    }*/
    if(isAuthenticated){
        return <Navigate to='/articles'/>
    }
    else {
        return <div className="wrapper-page">
            <div className="text-center ">
                <img src="./images/MunchFit-white.png" alt="logo" className="img-responsive center-block logo-adjust"/>
            </div>
            <div className="m-t-40 card-box">
                <div className="text-center">
                    <h4 className="text-uppercase font-bold m-b-0">Login</h4>
                </div>
                <div className="panel-body">
                    <form id="fLogin" className="form-horizontal m-t-20" onSubmit={handleSubmit(onSubmit, onError)}>
                        <div className="form-group ">
                            <div className="col-xs-12">
                                <input {...register("email")} className="form-control" type="email"
                                       placeholder="Username" required/>
                            </div>
                        </div>
                        <div className="form-group">
                            <div className="col-xs-12">
                                <input {...register("password")} className="form-control" type="password"
                                       placeholder="Password" required/>
                            </div>
                        </div>
                        <div className="form-group text-center m-t-30">
                            <div className="col-xs-12">
                                <button id="btnLogin"
                                        className="btn btn-custom btn-bordred btn-block waves-effect waves-light">Log In
                                </button>
                            </div>
                        </div>
                    </form>
                    {errors && <div className="alert alert-danger col-xs-12 col-md-12 mt-20" role="alert"
                          style={{display: "block"}}> Correo o contraseña no válidos
                    </div>}

                </div>
            </div>

        </div>
    }
}